import { IFormatter } from '../FormatterTypes';
import { TEDDisplayInt } from '../Displayers/TEDDisplayInt';
import { TEDParseInt } from '../Parsers/TEDParseInt';
import { TEDValidateNumber } from '../Validators/TEDValidateNumber';

class TEDFormatInt implements IFormatter {
  displayer = TEDDisplayInt.getInstance();
  parser = TEDParseInt.getInstance();
  validator = TEDValidateNumber.getInstance();
}

export { TEDFormatInt };
